import React, { useContext } from 'react';
import { ManagementModeContext, type ManagementMode } from './useManagementMode';

export function ManagementModeProvider({
  mode,
  isAgency = false,
  children,
}: {
  mode: ManagementMode;
  isAgency?: boolean;
  children: React.ReactNode;
}) {
  // Agency users keep full access regardless of the practice's mode — treat
  // them as guided so the existing AutopilotGuard / useManagementMode checks
  // automatically pass without every caller having to know about the role.
  const effectiveMode: ManagementMode = isAgency ? 'guided' : mode;
  return (
    <ManagementModeContext.Provider value={effectiveMode}>
      {children}
    </ManagementModeContext.Provider>
  );
}

/**
 * Renders children only in guided mode. In autopilot mode, the system
 * manages campaigns automatically so user actions are hidden.
 */
export function AutopilotGuard({ children }: { children: React.ReactNode }) {
  const mode = useContext(ManagementModeContext);
  if (mode === 'autopilot') return null;
  return <>{children}</>;
}
